<template>
  <div>
    <TrafficMenuTop />
    <TrafficMap />
    <!-- <br> -->
    <TrafficStatistic />
    <!-- <br> -->
    <TrafficChart />
    <TrafficChart2 />
    <!-- <br> -->
    <TrafficTable />
  </div>
</template>

<script>
import TrafficMap from '@/views/traffic/total/TrafficMap.vue'
import TrafficTable from '@/views/traffic/total/TrafficTable.vue'
import TrafficMenuTop from '@/views/traffic/total/TrafficMenuTop.vue'
import TrafficChart from '@/views/traffic/total/TrafficChart.vue'
import TrafficChart2 from '@/views/traffic/total/TrafficChart2.vue'
import TrafficStatistic from '@/views/traffic/total/TrafficStatistics.vue'
// import axios from '@axios'
export default {
  components: {
    TrafficMap,
    TrafficTable,
    TrafficMenuTop,
    TrafficChart,
    TrafficChart2,
    TrafficStatistic,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
